// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"40afae57","62":"96741d08","206":"24f2a65c","208":"cff9752e","335":"12048ab9","340":"969e221c","472":"5ff34b16","512":"872ba297","789":"9129450f","818":"6ec88ee6","926":"40afae57","962":"8fb2c4a4"}[chunkId] + ".chunk.css";
};